import { PowermeterLiveDataDto } from '../api'
import { PowermeterLiveDataModel } from '../models'

const fromPowermeterLiveDataDtoToModelTransformer = (dto: PowermeterLiveDataDto): PowermeterLiveDataModel => {
  return {
    type: dto.id,
    powerL1: dto.L1,
    powerL2: dto.L2,
    powerL3: dto.L3,
    deviceId: dto.deviceId?.toString(),
    deviceType: dto.deviceType,
  }
}
export default fromPowermeterLiveDataDtoToModelTransformer
